<template>
  <div>
    <md-table v-model="Nodes" style="  background-color:#428874;">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell
          v-if="item.data != null"
          md-label="Nom du secteur"
          @click.native="getpath(item.data.NodeId)"
          ><span
            :style="item.vanne.feedback == 1 ? 'color:green;' : 'color:gray;'"
            class="mdi mdi-circle"
          ></span>
          {{ item.data.FarmerName }}
        </md-table-cell>

        <md-table-cell md-label="">
          <div class="dropdown">
            <button
              @click="toggleDropdown(item.data.NodeId)"
              class="dropdown-button"
            >
              <i class="fas fa-ellipsis-v"></i> Actions
            </button>

            <div
              v-if="openDropdownId === item.data.NodeId"
              class="dropdown-content"
            >
              <button @click="modifyItem(item.data.NodeId)">
                <i class="fas fa-edit"></i> Modifier
              </button>
              <button @click="deleteItem(item.data.NodeId, item.data._id)">
                <i class="fas fa-trash-alt"></i> Supprimer
              </button>
            </div>
          </div>
        </md-table-cell> 
 <!--        <md-table-cell
          v-if="item.data != null"
          md-label="Superficie"
          @click.native="getpath(item.data.NodeId)"
        >
          {{ item.data.Totalarea }} ha</md-table-cell
        >  -->


        
        <md-table-cell md-label="Statut de la Vanne">
          
          <div style="display: flex; align-items: center;">
            
            <div
              v-if="item.vanne.connection_status === 'offline'"
              style="display: flex; align-items: center; gap: 10px;"
            >
              <toggle-button
                :disabled="item.vanne.mode === 'automatic'"
                :value="item.vanne.data === 31"
                color="#428874"
              />

              <i class="fas fa-exclamation-circle"></i>
              <span>Hors ligne</span>
            </div>


            <toggle-button
              v-else
              :disabled="item.vanne.mode === 'automatic'"
              :value="item.vanne.data === 31"
              color="#428874"
              @change="edit_on_off(item.data.NodeId, item.vanne.data)"
            />
          </div>
        </md-table-cell> 

 <!-- edit_auto -->
        <md-table-cell md-label="Mode d'Irrigation">
          <div style="display: flex; align-items: center;">

         
            <div class="switch-container">
      <span class="label-offline">Manuel</span>
      <input type="checkbox" id="switch" :checked="item.vanne.mode === 'automatic'"
       @change="onChangeMode(item.data.NodeId, $event.target.checked)">
      <label for="switch" class="label-toggle"></label>
      <span class="label-automatic">Automatique</span>
  </div>

           <!-- <div
              v-if="item.vanne.mode === 'automatic'"
              style="display: flex; align-items: center; gap: 10px;"
            >
            <i class="fas fa-robot"></i>
              <span>Automatic</span>
            </div> -->

        

          </div>
        </md-table-cell>


        
      </md-table-row>
    </md-table>

    <div v-if="showConfirmationDialog" class="modal-overlay">
      <!-- Confirmation Dialog -->
      <div class="confirmation-dialog">
        <p>
          Êtes-vous sûr de vouloir supprimer ce nœud avec l'ID:
          {{ selectedNodeId }}?
        </p>

        <!-- Modal buttons with same title and equal heights -->
        <div class="modal-buttons">
          <button class="oui-button" @click="confirmDeletion">Oui</button>
          <button class="non-button" @click="cancelDeletion">Non</button>
        </div>
      </div>
    </div>

    
  </div>
</template>

<style scoped>
.switch-container {
    display: flex;
    align-items: center;
}

.label-offline, .label-automatic {
    margin: 0 10px;
}

input[type="checkbox"] {
    -webkit-appearance: none;
    appearance: none;
    width: 40px;
    height: 20px;
    background-color: #ccc;
    border-radius: 20px;
    position: relative;
    cursor: pointer;
}

input[type="checkbox"]:checked::before {
    /* Style for the knob when checked */
    content: '';
    position: absolute;
    top: 2px;
    left: 22px;
    width: 16px;
    height: 16px;
    background-color: #428874;
    border-radius: 50%;
    transition: 0.2s;
}

input[type="checkbox"]::before {
    /* Style for the knob */
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 16px;
    height: 16px;
    background-color: white;
    border-radius: 50%;
    transition: 0.2s;
}

input[type="checkbox"]:disabled {
    background-color: #eaeaea;
    cursor: not-allowed;
}


.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black background */
  z-index: 1000; /* Higher z-index to cover the entire screen */
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Style for the modal dialog */
.confirmation-dialog {
  background-color: #fff; /* Background color for the modal */
  padding: 20px;
  border: 1px solid #ccc;
  z-index: 1001; /* Slightly higher z-index to appear above the overlay */
  border-radius: 8px; /* Rounded corners for the modal */
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5); /* 3D box shadow effect */
}

.confirmation-dialog p {
  margin: 0;
  font-size: 16px; /* Font size for the text */
  color: #333; /* Text color */
}

.confirmation-dialog button {
  text-align: center;
  margin-top: 20px;

  margin: 10px;
  padding: 10px 20px;
  background-color: #428874; /* Button background color */
  color: #fff; /* Button text color */
  border: none;
  border-radius: 4px; /* Rounded corners for buttons */
  cursor: pointer;
  transition: background-color 0.3s ease; /* Smooth hover effect */

  /* Hover effect */
  &:hover {
    background-color: #356c58; /* Darker background color on hover */
  }
}

.confirmation-dialog .modal-buttons button {
  margin: 0 10px;
  padding: 10px 20px;
  border: none;
  border-radius: 4px; /* Rounded corners for buttons */
  cursor: pointer;
  transition: background-color 0.3s ease; /* Smooth hover effect */
}

.confirmation-dialog .modal-buttons .oui-button {
  background-color: red;
  color: #fff;
}

/* Style for the "Non" button */
.confirmation-dialog .modal-buttons .non-button {
  background-color: #428874; /* Another color for "Non" */
  color: #fff; /* Text color */
}

.confirmation-dialog .modal-buttons button:hover {
  /* Hover effect for both buttons */
  background-color: #356c58;
}

.confirmation-dialog p {
  /* ... existing styles ... */
  font-size: 18px; /* Increase font size for the title */
  margin-bottom: 20px; /* Add some spacing between title and buttons */
}

.confirmation-dialog .modal-buttons {
  /* Center the buttons */
  text-align: center;
  margin-top: 20px;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-button {
  background: none;
  border: none;
  cursor: pointer;
  color: #428874;
  font-size: 16px; /* Adjust size as needed */
}

.dropdown-content {
  bottom: 0%;
  left: 0;
  display: block;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  z-index: 1000000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.3s ease;
}

.dropdown .dropdown-content {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-content button {
  background: none;
  border: none;
  color: black;
  padding: 12px 16px;
  text-align: left;
  width: 100%;
  display: flex;
  align-items: center;
}

.dropdown-content button i {
  margin-right: 8px; /* Space between icon and text */
}

.dropdown-content button:hover {
  background-color: #f1f1f1;
}
</style>
 
<script>

import router from "../../routes";
import GetNodes from "@/services/NodeData";
import { async } from "q";
export default {
  name: "simple-table",
  data() {
    return {
      showDropdown: {},
      openDropdownId: null,
      Off_on: true,
      selected: [],
      Nodes: [],
      showConfirmationDialog: false,
      selectedNodeId: null,
      selected_Id: null,
    };
  },
  methods: {
    deleteItem(nodeId, _id) {
      this.selectedNodeId = nodeId;
      this.selected_Id = _id;
      this.showConfirmationDialog = true;
    },
    async confirmDeletion() {
      try {
        // Call the deleteNode function to delete the node using _id
        const isDeleted = await GetNodes.deleteNode(this.selected_Id);
        if (isDeleted) {
          // Node deleted successfully, you can perform any necessary actions here
          console.log("Node deleted successfully");
          // Find the index of the node to delete in the Nodes array
          const indexToDelete = this.Nodes.findIndex(
            (node) => node.data._id === this.selected_Id
          );
          if (indexToDelete !== -1) {
            // Remove the node from the list
            this.Nodes.splice(indexToDelete, 1);
          }
        }
      } catch (error) {
        // Handle any errors that may occur during the deletion
        console.error("Error deleting node:", error);
      } finally {
        // Close the confirmation dialog
        this.showConfirmationDialog = false;
        this.selectedNodeId = null;
      }
    },

    cancelDeletion() {
      this.showConfirmationDialog = false;
      this.selectedNodeId = null;
    },
    toggleDropdown(nodeId) {
      if (this.openDropdownId === nodeId) {
        this.closeDropdown();
      } else {
        this.openDropdownId = nodeId;
        this.$nextTick(() => {
          document.addEventListener("click", this.handleClickOutside, true);
        });
      }
    },
    addClickOutsideListener(nodeId) {
      document.addEventListener("click", this.handleClickOutside);
    },
    closeDropdown() {
      this.openDropdownId = null;
      document.removeEventListener("click", this.handleClickOutside, true);
    },

    handleClickOutside(event) {
      const dropdown = this.$el.querySelector(`.dropdown-content`);
      if (dropdown && !dropdown.contains(event.target)) {
        this.closeDropdown();
      }
    },
    destroyed() {
      document.removeEventListener("click", this.handleClickOutside, true);
    },
    beforeDestroy() {
      document.removeEventListener("click", this.handleClickOutside);
    },

    modifyItem(nodeId) {
      console.log("modifyItem");

      this.$router.push({
        path: `/dashboard`,
        query: {
          id: nodeId,
          tab: 2,
        },
      });
    },
    getpath(id) {
      console.log(id);
      router.push(`/dashboard?id=${id}`);
    },
    edit_on_off(id, of) {
      if (of == 30) var active = 31;
      else var active = 30;

      GetNodes.edit_on_off(active, id)
        .then(async () => {
          const data = await GetNodes.getNodes();
          const promises = data.map(async (node) => {
            const dt = await GetNodes.getvanneAPI(node.NodeId);
            return { ...{ data: node }, ...{ vanne: dt } };
          });
          const newData = await Promise.all(promises);
          this.Nodes = newData;
        })
        .catch(() => (this.err = "Check the fields and try again"));
    },
    onChangeMode(id, isChecked) {
    const mode = isChecked ? 1 : 0; // Convertit l'état du checkbox en 1 ou 0
    this.edit_auto(id, mode);
  },
    edit_auto(id, of) 
    {

      GetNodes.edit_auto(of, id)
        .then(async () => 
        {

    

        })
        .catch(() => (this.err = "Check the fields and try again"));
    },
  },
  async created() {
    try {
      const data = await GetNodes.getNodes();
      console.log(data);

      // get Type from localStorage 
      const type = localStorage.getItem("Type");





      const promises = data.map(async (node) => 
      {
       try 
        {

          // if (type == "A") dont getvanneAPI and passe derict to return 
          if (type == "A") 
          {
            return { ...{ data: node }, ...{ vanne: { connection_status: "offline", mode: "automatic", data: 31 } } };
          }else
          {

          const dt = await GetNodes.getvanneAPI(node.NodeId); 
          if (!dt) { 
            return null;
          }


          return { ...{ data: node }, ...{ vanne: dt } };

        } 

        } catch (err) {
          console.error(
            `Error fetching or processing data for node ${node.NodeId}:`,
            err
          ); 
          return null;
        }  
      });
 
    
      try 
      {
        const newData = (await Promise.all(promises)).filter(
          (result) => result !== null
        );
 
        this.Nodes = newData;
      } catch (err) 
      {
        console.error("Error in Promise.all:", err);
      }
      
    } catch (err) {
      console.error("Error in created():", err);
    }
  },
};
</script>
